import React, { lazy, Suspense, useEffect, useState } from 'react';

const QuoteRequestDialog = lazy(() => import('./QuoteRequestDialog'));
export const DeferredQuoteDialog = ({ loadingTestId, ...props }) => {
  const [activated, setActivated] = useState(false);
  useEffect(() => { if (props.open) setActivated(true); }, [props.open]);
  if (!props.open && !activated) return null;
  // Keep the form mounted after first intent so closing it does not discard a draft.
  return <Suspense fallback={props.open ? <div role="status" data-testid={loadingTestId} className="fixed bottom-6 left-6 z-50 border bg-background text-foreground px-4 py-3 shadow-sm">Opening enquiry… <button type="button" data-testid={`${loadingTestId}-cancel`} onClick={() => props.onOpenChange(false)} className="ml-3 underline">Cancel</button></div> : null}>
    <QuoteRequestDialog testIdPrefix={loadingTestId === 'model-quote-opening' ? 'quote' : loadingTestId.replace(/-opening$/, '')} {...props} />
  </Suspense>;
};